import React from "react";
import { Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const MenuCard = ({ module, route, icon, name }) => {
  return (
    <Card className='m-3 index-card' cypressid={`${module}`}>
      <Card.Body className='text-center'>
        {route.includes("https://") ? (
          <a href={route} target='_blank' rel='noreferrer' aria-label={`${name} (opens in new tab)`}>
            <FontAwesomeIcon className='font-icon mb-2' icon={icon} style={{ color: "#147995", fontSize: "500%" }} aria-hidden="true" />
            <br />
            <span style={{ color: "#147995" }}>{name}</span>
          </a>
        ) : (
          <Link to={{ pathname: route, state: { module, route, icon, name } }} className='hyperlink'>
            <FontAwesomeIcon className='font-icon mb-2' icon={icon} style={{ color: "#147995", fontSize: "500%" }} aria-hidden="true" />
            <br />
            <span style={{ color: "#147995" }}>{name}</span>
          </Link>
        )}
      </Card.Body>
    </Card>
  );
};

export default MenuCard;
